/**
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */

import { Box, Text } from '@chakra-ui/react'
import type { JSX, ReactNode } from 'react'

export default function Placeholder({ children }: { children: ReactNode }): JSX.Element {
  return (
    <Box
      pos="absolute"
      top="2px"
      left="1px"
      display="inline-block"
      overflow="hidden"
      color="fg.subtle"
      whiteSpace="nowrap"
      userSelect="none"
      pointerEvents="none"
      textOverflow="ellipsis"
    >
      <Text>{children}</Text>
    </Box>
  )
}
